import { categories } from "@/mocks/content";

export default function Hero() {
  return (
    <section id="hero" className="relative overflow-hidden bg-background-950 text-background-100">
      <img
        src="https://readdy.ai/api/search-image?query=Moody%20abstract%20editorial%20background%20of%20layered%20dark%20textured%20paper%20sheets%20and%20faint%20press%20lines%2C%20warm%20ink%20tones%20with%20subtle%20deep%20vermillion%20and%20amber%20glow%20in%20the%20corners%2C%20cinematic%20vignette%2C%20grainy%20documentary%20newspaper%20aesthetic%2C%20minimalist%2C%20high%20contrast%2C%20no%20people%2C%20no%20readable%20text&width=1920&height=1080&seq=kanliao-hero&orientation=landscape"
        alt="看料网 深度内容媒体首屏背景"
        className="absolute inset-0 h-full w-full object-cover opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/55 to-background-950" />

      <div className="relative mx-auto flex min-h-[560px] w-full max-w-[1280px] flex-col justify-center px-4 py-24 md:min-h-[640px] md:px-6">
        <p className="mb-5 inline-flex w-fit items-center gap-2 rounded-full border border-accent-500/50 px-3 py-1.5 text-xs font-medium tracking-wide text-accent-300">
          <i className="ri-focus-3-line text-sm" />
          深度内容媒体 · 专注深挖内幕与背后真相
        </p>

        <h1 className="max-w-3xl font-heading text-4xl font-black leading-[1.15] tracking-tight text-background-50 md:text-6xl">
          事情，通常不止
          <span className="text-primary-400">表面这一层</span>。
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-200/90 md:text-lg">
          看料网围绕不常被看到的内容与独家线索做深度展示，点进隐藏细节与深层解析，
          把背后的关系图谱拉出来。适合已经吃透表象、想看懂更深一层的人。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <a
            href="#columns"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            进入深度栏目
            <i className="ri-arrow-down-line" />
          </a>
          <a
            href="#about"
            className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-200/30 px-6 py-3 text-sm font-semibold text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
          >
            我们的拆解原则
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-2">
          <span className="mr-1 text-xs text-background-400">快捷进入</span>
          {categories
            .filter((c) => c.key !== "all")
            .map((c) => (
              <a
                key={c.key}
                href="#columns"
                className="whitespace-nowrap rounded-full border border-background-200/25 px-3 py-1.5 text-xs text-background-200 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                {c.name}
              </a>
            ))}
        </div>

        <div className="mt-12 grid max-w-xl grid-cols-3 gap-px overflow-hidden rounded-lg border border-background-200/20">
          {[
            { n: "120+", t: "深度拆解选题" },
            { n: "3 级", t: "可信度分级" },
            { n: "全部", t: "公开信息可复核" },
          ].map((s) => (
            <div key={s.t} className="bg-background-100/5 px-4 py-3">
              <p className="font-heading text-xl font-black text-accent-300">{s.n}</p>
              <p className="mt-0.5 text-xs text-background-300">{s.t}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}